import React, { useEffect } from 'react';
import { Content, FlexboxGrid } from 'rsuite';
import PortalHeader from '../../components/layout/PortalHeader';
import { FLOWS_ENUM } from '../../common/enums';
import Success from '../../components/payment/common/success/Success';
import AdminUpdateSuccessFields from '../../components/payment/common/success/AdminUpdateSuccessFields';
import { useDispatch } from 'react-redux';
import { resetAdminUpdateState } from '../../store/slices/adminUpdate/adminUpdateSlice';

const AdminUpdateSuccess = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(resetAdminUpdateState());
  }, [dispatch]);

  return (
    <FlexboxGrid justify="space-between">
      <FlexboxGrid.Item colspan={24}>
        <PortalHeader
          flow={FLOWS_ENUM.ADMIN_UPDATE}
          showAccountDropdown={false}
        />
      </FlexboxGrid.Item>
      <FlexboxGrid.Item colspan={24}>
        <Content>
          <Success
            successComponent={() => <AdminUpdateSuccessFields />}
            showReturnToDashboardButton={false}
          />
        </Content>
      </FlexboxGrid.Item>
    </FlexboxGrid>
  );
};

export default AdminUpdateSuccess;
